import { FacetValue } from '@models';
import { BaseFacetComponent } from '../base-facet.component';
import defaultHtml from './size-facet.component.hbs';

interface SizeFacetValue extends FacetValue {
    visible: boolean;
}

export class SizeFacetComponent extends BaseFacetComponent {
    protected override customTemplatePropertyName = 'colorFacet';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data) {
            return '';
        }

        const filterRegex = this.state.filter ? new RegExp(this.state.filter, 'i') : undefined;

        const html = template({
            values:
                this.data.values?.map(
                    (v, i): SizeFacetValue => ({
                        ...v,
                        visible:
                            (!filterRegex && (this.state.toggled || !this.data!.truncateThreshold || i < this.data!.truncateThreshold!)) ||
                            (!!filterRegex && filterRegex.test(v.title ?? ''))
                    })
                ) ?? [],
            showToggle: !!this.data.truncateThreshold && (this.data.values?.length ?? 0) > this.data.truncateThreshold && !this.state.filter,
            toggleText: this.state.toggled ? 'Show fewer' : 'Show more',
            expanded: this.state.toggled
        });

        return html;
    }
}
